// extracted by mini-css-extract-plugin
export default {"product_drawer_header":"Wq","subtitle":"Xq","in_subscription":"Yq","items":"Zq","title":"ar","recommended":"br"};
    if(module.hot) {
      // 1711394575972
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  